import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const BookmarkSelectedIcon = forwardRef<SVGSVGElement, IconProps>(function BookmarkSelectedIcon(
  { color = '', height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg ref={ref} width={width} height={height} viewBox="0 0 18 18" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 8.90873V8.94976C3.99999 11.237 4.08868 12.8139 4.15588 13.6803C4.24274 14.8002 5.4993 15.3687 6.39832 14.7379C6.93134 14.3733 7.42217 13.9825 7.79314 13.6872C7.96767 13.5483 8.11573 13.4304 8.22911 13.3463C8.64863 13.0354 8.82817 12.9995 9 12.9995C9.17183 12.9995 9.35136 13.0354 9.77088 13.3463C9.88427 13.4304 10.0323 13.5482 10.2068 13.6872C10.5778 13.9825 11.0687 14.3733 11.6017 14.7379C12.5007 15.3687 13.7572 14.8002 13.8441 13.6803C13.9113 12.8139 14 11.237 14 8.94977V8.90915C14 8.01361 14 7.19809 13.9328 6.50986C13.8647 5.81345 13.7188 5.1206 13.3404 4.53394C12.5225 3.266 10.983 2.99199 8.99587 3.00018C7.013 3.00834 5.47732 3.28527 4.66093 4.54429C4.28163 5.12925 4.13543 5.81966 4.06728 6.51413C3.99997 7.19998 3.99998 8.01355 4 8.90873Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4794 6.03042C10.3847 6.00491 10.2705 6.00181 10 6.00181C9.72386 6.00181 9.5 5.77796 9.5 5.50183C9.5 5.2257 9.72386 5.00186 10 5.00186C10.0123 5.00186 10.0247 5.00184 10.0372 5.00183C10.2575 5.00163 10.5037 5.00139 10.7394 5.06485C11.017 5.13961 11.2467 5.28912 11.4781 5.51995C11.6602 5.70155 11.7601 5.94567 11.8212 6.15139C11.8856 6.36852 11.9249 6.60793 11.9501 6.83445C12 7.28424 12 7.74448 12 7.99384V7.99976C12 8.27589 11.7761 8.49973 11.5 8.49973C11.2239 8.49973 11 8.27589 11 7.99976C11 7.74773 10.9996 7.33583 10.9562 6.94478C10.9345 6.7491 10.9035 6.57417 10.8624 6.43577C10.8421 6.36725 10.8215 6.31518 10.8025 6.2777C10.7848 6.24262 10.7719 6.22798 10.7719 6.22798C10.6284 6.08479 10.5455 6.04821 10.4794 6.03042Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
